import { compact } from "lodash";
import { ProjectFragment } from "@graphql";
import locale from "@bonliva-crm/locale";

export function projectsToOptions(projects: ProjectFragment[]) {
  const options = projects.map((project) => {
    let parts = [
      project.Owner ? { ...project.Owner, role: "Owner" } : null,
      project.Admin ? { ...project.Admin, role: "Admin" } : null,
      ...compact(project.Members).map((x) => ({ ...x, role: "Member" }))
    ].filter((x) => x);

    if (
      project.Owner &&
      project.Admin &&
      project.Owner.PersonId === project.Admin.PersonId
    ) {
      parts = parts.filter((x) => x.role !== "Admin");
      parts.find((x) => x.role === "Owner").role = "Owner/Admin";
    }

    const members = (project.Members || []).filter((x) =>
      project.Owner ? x.PersonId !== project.Owner.PersonId : true
    );

    let description = parts
      .filter((x) => x.role !== "Member")
      .map((x) => `${x.role}: ${x.Name}`)
      .join(", ");

    if (members.length > 0) {
      description = `${description}, ${locale.Member}: ${members
        .map((x) => x.Name)
        .join(", ")}`;
    }

    return {
      description,
      label: `${project.Name} (${project.ProjectNumber})`,
      value: project._id
    };
  });

  return options;
}
